// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3zxK2","upload":"Small_upload__1tkQL","imageWrap":"Small_imageWrap__179YI","removeBtn":"Small_removeBtn__2xldX"};